module.exports = __webpack_public_path__ + "img/vk.c0770122.png";